
export default {
  props: {
    status: {type: String, required: true}
  },
  watch: {
    status: function () {
      this.animate()
    }
  },
  async mounted(){
    this.animate()
  },
  methods: {
    animate() {
      const animator = this.$refs.animator
      animator.className = 'loader-text fira-code-400'
      requestAnimationFrame(() => requestAnimationFrame(() => animator.className = 'loader-text fira-code-400 typing'))
    }
  }
}
